import { EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
var InvalidAccountLevelNotificationComponent = /** @class */ (function () {
    function InvalidAccountLevelNotificationComponent(_userService) {
        this._userService = _userService;
        this.openContactSupport = new EventEmitter();
        this.upgradeAccountEvt = new EventEmitter();
    }
    Object.defineProperty(InvalidAccountLevelNotificationComponent.prototype, "isSsoUser", {
        get: function () {
            return this._userService.isSsoUser;
        },
        enumerable: true,
        configurable: true
    });
    InvalidAccountLevelNotificationComponent.prototype.contactSupport = function () {
        this.openContactSupport.emit();
    };
    InvalidAccountLevelNotificationComponent.prototype.startTrial = function () {
        this.upgradeAccountEvt.emit({
            startTrial: true
        });
    };
    InvalidAccountLevelNotificationComponent.prototype.upgradeAccount = function () {
        this.upgradeAccountEvt.emit({
            startTrial: false
        });
    };
    return InvalidAccountLevelNotificationComponent;
}());
export { InvalidAccountLevelNotificationComponent };



// WEBPACK FOOTER //
// ./src/app/main/invalid-account-level-notification/invalid-account-level-notification.component.ts.pre-build-optimizer.js